skrilla.directive('userVerifications', function () {
    return {
        templateUrl: 'directives/userVerifications/userVerifications.html',
        scope: {
            user: "=",
            refresh: "="
        },
        controller: function ($scope,
                              searchService,
                              objectChangeService,
                              countryService,
                              valuesToWordsService,
                              modalService,
                              profileTagService,
                              adminService,
                              currencyService,
                              queryService,
                              constantsService,
                              dateService) {
            $scope.hasRole = adminService.hasRole;
            $scope.verificationStatuses = constantsService.getVerificationStatuses();
            $scope.key = "userDetails";
            objectChangeService.registerObject($scope.key, "user", $scope);
            $scope.hasChanged = objectChangeService.hasValueChanged;
            $scope.countries = countryService.getAllCountries();
            $scope.currencies = currencyService.getCurrencies()
            $scope.ipAddress = null;

            $scope.cardVerificationStatus = 'UNKNOWN';
            $scope.testPermissions = function() {
                const queryString = queryService.getQueryString({
                    userId: $scope.user.id,
                    ipAddress: $scope.ipAddress
                })
                searchService.get("permissions/test" + queryString ).then(function (response) {
                    $scope.permissions = response.data;
                    $scope.cardVerificationStatus = $scope.permissions && $scope.permissions['withdraw_AUD'] ? $scope.permissions['withdraw_AUD'] : 'UNKNOWN';
                    $scope.cardVerificationRequired = $scope.cardVerificationStatus.startsWith('CC_UNVERIFIED')
                });
            }
            $scope.testPermissions()

            $scope.getVerifications = function() {
                searchService.get("users/" + $scope.user.id + "/verifications" ).then(function (response) {
                    // $scope.verifications = response.data.result
                    if (response.data.result && response.data.result[0]) {
                        $scope.currentVerification = response.data.result[0]
                        $scope.verifications = response.data.result.slice(1)
                    } else {
                        $scope.currentVerification = null
                        $scope.verifications = []
                    }
                });
            }
            $scope.getVerifications()

            $scope.attemptUserVerification = function(){
                modalService.confirm("Are you sure you'd like to attempt verify this user with our KYC provider ?", function(){
                    searchService.put("users/" + $scope.user.id + "/attemptUserVerification", {}, "User Verification Attempted!").then(function(response) {
                        $scope.user = response.data;
                        objectChangeService.registerObject($scope.key, "user", $scope);
                    });
                });
            }

            $scope.verify = function(){
                modalService.confirm("Are you sure you'd like to verify this user?", function(){
                    searchService.put("users/" + $scope.user.id + "/verificationStatus", {verificationStatus: "VERIFIED_ADMIN"}, "User Successfully verifed!").then(function(response) {
                        $scope.user.verificationStatus = "VERIFIED_ADMIN";
                        objectChangeService.registerObject($scope.key, "user", $scope);
                    });
                });
            }

            $scope.reload = function () {
                modalService.confirm("Reload the latest status and data from this verification from the KYC provider ?", function () {
                    searchService.put("users/" + $scope.user.id + "/reloadUserVerification", {}, "User Verification loaded!").then(function (response) {
                        $scope.user = response.data;
                        objectChangeService.registerObject($scope.key, "user", $scope);
                        $scope.getVerifications()
                    });
                });
            }

            $scope.verifyEmail = function(){
                modalService.confirm("Are you sure you would like to verify this user's email? This could also attempt to verify their identity", function(){
                    searchService.put("users/" + $scope.user.id + "/verifyEmail", {}, "User Email Successfully verified!").then(function(response) {
                        $scope.user.emailVerificationStatus = "VERIFIED";
                        objectChangeService.registerObject($scope.key, "user", $scope);
                    });
                });
            }


            $scope.unVerify = function(){
                modalService.confirm("Are you sure you'd like to unverify this user?", function() {
                    searchService.put("users/" + $scope.user.id + "/verificationStatus", {verificationStatus: "FAILED"}, "User Successfully unverifed!").then(function (response) {
                        $scope.user.verificationStatus = "FAILED";
                        objectChangeService.registerObject($scope.key, "user", $scope);
                    });
                });
            }

        }
    };
});
